import React, {useCallback, useEffect, useState} from 'react';
import {useLocation, useNavigate} from "react-router";
import {useTranslation} from 'react-i18next';
import {AxiosError} from 'axios';
import {Location} from 'history';
import client from 'lib/CommonApi/client';
import {
  callAlertWeb,
  callNativeWeb,
  footerShowEventWeb,
  hideProgressWeb,
  showProgressWeb
} from 'common/appInterface';
import stringUtils from 'common/stringUtils';
import { CardListSummary, CardProductCodeName } from '../../constants/Card';
import CardListSummaryItem from 'components/CardListSummaryItem';
import { getVersionUrl } from 'common/cacheOverwrite';

const NologinProductListPage: React.FC = () => {
  /** Location State */
  const location = useLocation() as Location<LocationState>;
  /** Navigate */
  const navigate = useNavigate();
  /** 다국어처리 */
  const { t, i18n } = useTranslation();

  const screenId = "APPL01";
  const screenName = t("APPL01.title");

  const [productList, setProdcutList] = useState<Product[]>([]);

  /** 카드상품 조회 */
  const callProductList = useCallback(async () => {
    showProgressWeb();
    await client.get("/api/nologin/product", { params: location.state.query }).then(response => {
      if (!stringUtils.checkValueNull(response.data.response)) {
        setProdcutList(response.data.response);
      }
    }).catch((e: AxiosError) => {
      callAlertWeb("ERROR", "99", e.message);
    }).finally(() => {
      hideProgressWeb();
    });
  }, [location]);

  /** 카드신청 클릭 → 비로그인 카드상세 (퀵카드도 상세에서 로그인) */
  const clickApply = useCallback((e: React.MouseEvent<HTMLLIElement, MouseEvent>) => {
    const cardProductCode = e.currentTarget.dataset["code"];

    navigate("/nologin/product/" + cardProductCode, { state: location.state });
  }, [location, navigate]);

  // 최초실행
  useEffect(() => {
    // 언어설정
    i18n.changeLanguage(location.state.query.languageCode);
    // callNative_Web 처리 (WEB > APP)
    callNativeWeb(screenId, screenName, "Y");
    // 하단바 제어
    footerShowEventWeb("Y");

    console.log("QUERY STATE");
    console.log(location.state);

    callProductList();

    // 최초한번실행 useEffect() Warning 제거
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div id="wrap">
      <div id="container" className="pcHidden">
        <section className="contents cardWrapSub cardSummaryWrap">
          <div className="inner">
            <div className="section cardListWrap">
              <ul className="cardList">
                {productList.map((value) => {
                  // 카테고리 요약 카드 (Premier·Dream·Welcome·Quick). 상품 영역 전체가 터치 영역
                  if (CardListSummary[Number(value.cardProductCode)]) {
                    return <CardListSummaryItem key={value.cardProductCode} cardProductCode={value.cardProductCode} onClick={clickApply} />;
                  }

                  return (
                    <li className="card clfix cardActive" key={value.cardProductCode} onClick={clickApply} data-code={value.cardProductCode}>
                      <div className="thumb">
                        <img src={getVersionUrl(localStorage.getItem(`${value.cardProductCode}_B`) as string)} alt="" />
                        <img src={getVersionUrl(localStorage.getItem(`${value.cardProductCode}_C`) as string)} alt="" />
                        <div className="description">
                          <span className="tit">{CardProductCodeName[Number(value.cardProductCode)]}</span>
                          <ul className="name">
                            <li>{t(`APPL01.explan01.${value.cardProductCode}`)}</li>
                          </ul>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default NologinProductListPage;